// @ts-ignore Untyped
import { STATIC_SECTION } from 'layout-data-lib/LayoutDataTree/helpers';
export const isSavedSection = section => Boolean(section.marketerSection);
export const isDeveloperSection = section => !section.marketerSection;
export const isEmbed = section => Boolean(section.isEmbed);

// TODO: Turn this into a type guard when we have better types for sectionTree
export const isFixedLayoutSection = section => section.sectionTree && section.sectionTree.type === STATIC_SECTION;